import React, { useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import InternalCarousal from "../InternalPages/Carousal-ExpandedView/InternalCarousal";
import { useSelector } from "react-redux";
import { LIBRARY_CONSTANT } from "../../constant/constant";
import ListViewDesign from "../InternalPages/ListView/ListViewDesign";
import { darkTheme, lightTheme } from "../../theme/Theme";

export default function LibraryTabContent({ data, grid, currentTab }) {
  const isMobile = useMediaQuery("(max-width: 600px)");

  const { documents, links, videos } = data;

  const { selectedGlobalState } = useSelector((store) => store.internalPage);
  const [localState, setLocalState] = useState(selectedGlobalState);
  useEffect(() => {
    if (localState !== selectedGlobalState) {
      setLocalState(selectedGlobalState);
    }
  }, [selectedGlobalState]);

  const isDarkTheme = useSelector((state) => state.theme);

  return (
    <div
      style={{
        background: isDarkTheme
          ? darkTheme.backgroundColorLayer2
          : lightTheme.backgroundColorLayer2,
        borderRadius: "8px",
      }}
    >
      {grid === "tile" && (
        <Box
          sx={{
            width: isMobile ? "100%" : "auto",
            flex: "0 0 auto",
            height: "auto",
            borderRadius: "8px",
          }}
        >
          {documents?.length > 0 &&
            (currentTab === LIBRARY_CONSTANT.document ||
              currentTab === LIBRARY_CONSTANT.all) && (
              <InternalCarousal
                data={documents}
                content={"Documents"}
                heading={"Documents"}
                flexDirection={"column"}
                localState={localState}
                setLocalState={setLocalState}
              />
            )}

          {videos?.length > 0 &&
            (currentTab === LIBRARY_CONSTANT.videos ||
              currentTab === LIBRARY_CONSTANT.all) && (
              <InternalCarousal
                data={videos}
                content={"Videos"}
                heading={"Videos"}
                flexDirection={"column"}
                localState={localState}
                setLocalState={setLocalState}
              />
            )}

          {/* Links Carousal */}
          {links?.length > 0 &&
            (currentTab === LIBRARY_CONSTANT.links ||
              currentTab === LIBRARY_CONSTANT.all) && (
              <InternalCarousal
                data={links}
                content={"Links"}
                heading={"Links"}
                flexDirection={"column"}
                localState={localState}
                setLocalState={setLocalState}
              />
            )}
        </Box>
      )}
      {grid !== "tile" && (
        <Box
          sx={{
            width: isMobile ? "100%" : "auto",
            flex: "0 0 auto",
            height: "auto",
            boxShadow: `0px 0px 24px 0px rgba(0, 92, 188, 0.08)`,
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          {/* Documents Carousal */}
          {documents?.length > 0 &&
            (currentTab === LIBRARY_CONSTANT.document ||
              currentTab === LIBRARY_CONSTANT.all) && (
              <ListViewDesign
                data={documents}
                content={"Documents"}
                pageType={"LibraryDetails"}
                viewMode={grid}
                localState={localState}
                setLocalState={setLocalState}
              />
            )}

          {videos?.length > 0 &&
            (currentTab === LIBRARY_CONSTANT.videos ||
              currentTab === LIBRARY_CONSTANT.all) && (
              <ListViewDesign
                data={videos}
                content={"Videos"}
                pageType={"LibraryDetails"}
                viewMode={grid}
                localState={localState}
                setLocalState={setLocalState}
              />
            )}
          {links?.length > 0 &&
            (currentTab === LIBRARY_CONSTANT.links ||
              currentTab === LIBRARY_CONSTANT.all) && (
              <ListViewDesign
                data={links}
                content={"Links"}
                pageType={"LibraryDetails"}
                viewMode={grid}
                localState={localState}
                setLocalState={setLocalState}
              />
            )}
        </Box>
      )}
    </div>
  );
}
